import Button from 'atoms/Button/Button';
import React, { PropsWithChildren, ReactElement } from 'react';
import { headingToKey } from 'src/functions/getTableOfContentDictionary';

interface AnchorToControllerProps extends PropsWithChildren {
  href: string;
}

const anchorIsExternalUrl = (href: string): boolean =>
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(href);

const anchorIsInternalUrl = (href: string): boolean => /^\/(?!\/)/.test(href);

const isUrlLink = (href: string): boolean => anchorIsExternalUrl(href) || anchorIsInternalUrl(href);

const AnchorCellHandler = ({ href, children }: AnchorToControllerProps): JSX.Element => {
  if (!href) return children as ReactElement;

  if (isUrlLink(href)) {
    return (
      <Button
        variant='brand-text-link'
        size='sm'
        href={href}
      >
        {children}
      </Button>
    );
  }

  const anchorToAsKey = headingToKey(href);

  const handleGoToSection = () => {
    const element = document.querySelector(`#${anchorToAsKey}`);

    if (!element || typeof window === 'undefined') return;

    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 80,
      behavior: 'smooth',
    });
  };

  return (
    <Button
      variant='brand-text-link'
      size='sm'
      onClick={handleGoToSection}
    >
      {children}
    </Button>
  );
};

export default AnchorCellHandler;
